/**
 * Stable Map Layers checkbox labels for WFS + raster companion groups.
 * Keep these in sync with CompanionLevelSwitcher visibility matching.
 */
export const COMPANION_FOOTPRINT_TITLE = 'Footprint';
export const COMPANION_IMAGE_TITLE = 'Image';

/** Id suffix for the optional secondary-CQL WMS (e.g. MACRO), hidden from checkboxes. */
export const COMPANION_SECONDARY_RASTER_ID_SUFFIX = '-raster-secondary';

export function isCompanionSecondaryRasterId(
  layerId: string | undefined,
): boolean {
  return Boolean(
    layerId && layerId.endsWith(COMPANION_SECONDARY_RASTER_ID_SUFFIX),
  );
}

export function isCompanionFootprintTitle(title: string | undefined): boolean {
  if (!title) return false;
  return (
    title === COMPANION_FOOTPRINT_TITLE ||
    title.startsWith(`${COMPANION_FOOTPRINT_TITLE} `)
  );
}

export function isCompanionImageTitle(title: string | undefined): boolean {
  if (!title) return false;
  return (
    title === COMPANION_IMAGE_TITLE ||
    title.startsWith(`${COMPANION_IMAGE_TITLE} `)
  );
}

export function isCompanionRoleTitle(title: string | undefined): boolean {
  return isCompanionFootprintTitle(title) || isCompanionImageTitle(title);
}
